import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import Handler from '@/core/domain/usecase/handler';

export interface FetchScreensRepository {
    (): Promise<Screen[]>
}

const fetchScreensRepository = (axios: AxiosInstance): FetchScreensRepository => async () => {
    try {
        const response: AxiosResponse = await axios.get('/screen')
        const screens: Screen[] = response.data
        return screens
    } catch (err: any | AxiosError) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default fetchScreensRepository